import React from 'react'
import type { Comment } from '../../types'
import { CommentItem } from './CommentItem'
import { LoadingSpinner } from '../ui/LoadingSpinner'

interface CommentListProps {
  comments: Comment[]
  loading: boolean
  error: string | null
  onLike: (id: string) => void
  onDelete: (id: string) => void
  onReply: (body: string, parentId: string) => Promise<boolean>
}

export const CommentList: React.FC<CommentListProps> = ({
  comments,
  loading,
  error,
  onLike,
  onDelete,
  onReply,
}) => {
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '20px 0' }}>
        <LoadingSpinner />
        <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.82rem', color: 'var(--text-secondary)' }}>
          loading comments...
        </span>
      </div>
    )
  }

  if (error) {
    return (
      <div
        style={{
          padding: '12px',
          background: 'rgba(248,113,113,0.06)',
          border: '0.5px solid rgba(248,113,113,0.2)',
          borderRadius: 'var(--radius-sm)',
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: '0.82rem',
          color: 'var(--accent-red)',
        }}
      >
        [ERROR] {error}
      </div>
    )
  }

  if (comments.length === 0) {
    return (
      <p
        style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: '0.82rem',
          color: 'var(--text-muted)',
          padding: '16px 0',
        }}
      >
        // No comments yet. Be the first!
      </p>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          onLike={onLike}
          onDelete={onDelete}
          onReply={onReply}
        />
      ))}
    </div>
  )
}
